import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'xsImage',
  pure: false,
})
export class XsImagePipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): unknown {
    const defaultImagePath = './assets/images/';

    /** use default path if not provided as argument */
    const basePath = args.length === 0 ? defaultImagePath : args[0];

    const theme = localStorage.getItem('XSightTheme') ? localStorage.getItem('XSightTheme') : 'lightMode';
    const path = basePath + theme + '/' + value;
    return path;
  }
}
